export const SandboxEyelash = () => {
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={true}
        >
            <path
                d="M16.921 10.685C17.0618 10.7276 19.1553 9.41724 18.5076 9.32497C18.2847 9.2543 18.0966 9.35123 18.0612 9.61099C17.9438 9.18625 17.6095 9.95961 17.3966 9.89479C17.4276 9.55083 16.9215 10.4545 16.9945 10.0794C14.6379 10.7166 10.3476 15.7377 15.8104 11.5018C15.2281 11.5989 15.7461 11.2493 16.0084 11.2117C15.6937 11.7678 16.7122 10.9707 16.891 10.7491C16.5635 10.8957 17.0695 10.37 16.9199 10.6844L16.921 10.685Z"
                fill="#101214"
            />
            <path
                d="M12.2785 8.63465C12.578 8.48752 13.5816 5.74008 13.7157 5.46236C13.9162 4.83357 13.2168 5.08505 13.1559 5.57465C13.1082 5.67408 12.9857 6.38634 12.8132 6.176C12.2384 6.56404 12.2888 7.72355 11.7981 8.00358C11.8954 8.11813 11.7396 8.3692 11.7916 8.45133C11.6412 8.49666 11.5837 8.74556 11.6215 8.74978C11.0531 9.57123 11.9162 9.89496 12.1629 8.95495C12.1925 8.97827 12.3485 8.7651 12.2788 8.63677L12.2785 8.63465Z"
                fill="#101214"
            />
            <path
                d="M4.10194 7.71618C3.8741 8.19769 3.84724 7.802 3.96035 7.56774C4.24273 7.79454 4.15214 7.02536 4.04729 6.86258C4.04165 6.94881 3.91446 7.01568 3.91709 6.84016C4.24354 6.86395 4.25351 4.65154 3.60716 5.887C3.60935 5.92409 3.86502 5.86471 3.78668 5.93229C3.39822 5.9737 3.6766 6.23797 3.70855 6.32629C3.50767 6.38388 3.69659 6.42076 3.61407 6.46998C3.34093 6.4316 3.80701 6.85736 3.53611 6.80239C3.13798 7.42702 3.70488 8.25986 3.34063 8.7551C3.79869 8.8857 3.16332 10.6946 4.01069 9.81741C4.1888 9.06611 4.28468 8.46564 4.10194 7.71618Z"
                fill="#101214"
            />
            <path
                d="M8.61267 2.16755C7.98828 2.17842 8.16049 3.64788 7.91657 4.1339C7.56595 4.73857 6.44055 10.4487 7.62641 8.69913C7.95464 6.97126 8.4806 5.546 8.65333 3.45861C8.7031 3.11569 9.04515 1.99472 8.61267 2.16755Z"
                fill="#101214"
            />
            <path
                d="M14.5105 16.6145C14.1701 17.2808 13.642 16.7392 13.3165 17.3009C12.8318 18.3364 17.4291 17.245 17.2574 16.3846C17.015 15.6938 14.8465 16.8467 14.5105 16.6145Z"
                fill="#101214"
            />
        </svg>
    );
};
